// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  box-sizing: border-box;
}

body, html, #root {
  height: 100%;
  margin: 0;
  font-family: "Inter", sans-serif;
}

.login-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: #0a0f1c;
}

.login-box {
  display: grid;
  grid-template-columns: 1.2fr 1fr;
  width: 900px;
  max-width: 95%;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0,0,0,0.5);
  background: transparent; /* make sections' bg smooth */
}

/* Brand Section */
.brand-section {
  background: #1e293b;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 50px;
  text-align: center;
  border-right: none; /* remove any border line */
}

.brand-section img {
  width: 250px;
  margin-bottom: 20px;
}

.brand-section h1 {
  color:#e6cd6cfd;
  margin: 8px 0 4px;
  font-size: 26px;
}

.brand-section p {
  color: #94a3b8;
  font-size: 14px;
}

/* Form Section */
.form-section {
  padding: 50px 40px;
  background: #0f172a;
  display: flex;
  flex-direction: column;
  justify-content: center;
  border-left: none; /* remove any border line */
}

.form-section h2 {
  font-size: 22px;
  margin-bottom: 6px;
  color:#e6cd6cfd;
}

.form-section span {
  font-size: 13px;
  color: #94a3b8;
  margin-bottom: 20px;
}

.field {
  margin-top: 16px;
}

label {
  display: block;
  font-size: 12px;
  margin-bottom: 6px;
  color: #cbd5e1;
}

input {
  width: 100%;
  padding: 12px 14px;
  border-radius: 8px;
  border: 1px solid #1e293b;
  /* color: #ffffff; */
}

.password-box {
  position: relative;
}

.password-box i {
  position: absolute;
  right: 14px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  font-size: 18px;
  color: #e6cd6cfd;
}

.forgot {
  text-align: right;
  margin-top: 8px;
  font-size: 12px;
  color: #e6cd6cfd;
  cursor: pointer;
}

.btn-login {
  width: 100%;
  margin-top: 30px; /* spacing before button */
  padding: 12px;
  border-radius: 8px;
  border: none;
  background: #e6cd6cfd;
  font-weight: bold;
  color: #0f172a;
  cursor: pointer;
  transition: all 0.3s;
  align-self: stretch; /* full width */
}

.btn-login:hover {
  box-shadow: 0 4px 15px rgba(250, 204, 21, 0.5);
}

footer {
  margin-top: 20px;
  font-size: 11px;
  color: #64748b;
  text-align: center;
}

/* Responsive */
@media (max-width: 900px) {
  .login-box {
    grid-template-columns: 1fr;
  }

  .brand-section {
    padding: 30px;
  }

  .brand-section img {
    width: 180px;
  }

  .form-section {
    padding: 30px 20px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Login/Login.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uCAAuC;EACvC,uBAAuB,EAAE,6BAA6B;AACxD;;AAEA,kBAAkB;AAClB;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,kBAAkB,EAAE,2BAA2B;AACjD;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,iBAAiB,EAAE,2BAA2B;AAChD;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gBAAgB,EAAE,0BAA0B;EAC5C,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,qBAAqB;EACrB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,mBAAmB,EAAE,eAAe;AACtC;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA,eAAe;AACf;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":["* {\n  box-sizing: border-box;\n}\n\nbody, html, #root {\n  height: 100%;\n  margin: 0;\n  font-family: \"Inter\", sans-serif;\n}\n\n.login-wrapper {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 100vh;\n  background: #0a0f1c;\n}\n\n.login-box {\n  display: grid;\n  grid-template-columns: 1.2fr 1fr;\n  width: 900px;\n  max-width: 95%;\n  border-radius: 16px;\n  overflow: hidden;\n  box-shadow: 0 10px 30px rgba(0,0,0,0.5);\n  background: transparent; /* make sections' bg smooth */\n}\n\n/* Brand Section */\n.brand-section {\n  background: #1e293b;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  padding: 50px;\n  text-align: center;\n  border-right: none; /* remove any border line */\n}\n\n.brand-section img {\n  width: 250px;\n  margin-bottom: 20px;\n}\n\n.brand-section h1 {\n  color:#e6cd6cfd;\n  margin: 8px 0 4px;\n  font-size: 26px;\n}\n\n.brand-section p {\n  color: #94a3b8;\n  font-size: 14px;\n}\n\n/* Form Section */\n.form-section {\n  padding: 50px 40px;\n  background: #0f172a;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  border-left: none; /* remove any border line */\n}\n\n.form-section h2 {\n  font-size: 22px;\n  margin-bottom: 6px;\n  color:#e6cd6cfd;\n}\n\n.form-section span {\n  font-size: 13px;\n  color: #94a3b8;\n  margin-bottom: 20px;\n}\n\n.field {\n  margin-top: 16px;\n}\n\nlabel {\n  display: block;\n  font-size: 12px;\n  margin-bottom: 6px;\n  color: #cbd5e1;\n}\n\ninput {\n  width: 100%;\n  padding: 12px 14px;\n  border-radius: 8px;\n  border: 1px solid #1e293b;\n  /* color: #ffffff; */\n}\n\n.password-box {\n  position: relative;\n}\n\n.password-box i {\n  position: absolute;\n  right: 14px;\n  top: 50%;\n  transform: translateY(-50%);\n  cursor: pointer;\n  font-size: 18px;\n  color: #e6cd6cfd;\n}\n\n.forgot {\n  text-align: right;\n  margin-top: 8px;\n  font-size: 12px;\n  color: #e6cd6cfd;\n  cursor: pointer;\n}\n\n.btn-login {\n  width: 100%;\n  margin-top: 30px; /* spacing before button */\n  padding: 12px;\n  border-radius: 8px;\n  border: none;\n  background: #e6cd6cfd;\n  font-weight: bold;\n  color: #0f172a;\n  cursor: pointer;\n  transition: all 0.3s;\n  align-self: stretch; /* full width */\n}\n\n.btn-login:hover {\n  box-shadow: 0 4px 15px rgba(250, 204, 21, 0.5);\n}\n\nfooter {\n  margin-top: 20px;\n  font-size: 11px;\n  color: #64748b;\n  text-align: center;\n}\n\n/* Responsive */\n@media (max-width: 900px) {\n  .login-box {\n    grid-template-columns: 1fr;\n  }\n\n  .brand-section {\n    padding: 30px;\n  }\n\n  .brand-section img {\n    width: 180px;\n  }\n\n  .form-section {\n    padding: 30px 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
